import styled, { css } from 'styled-components';

import { Chip } from '../index.tsx';

export const S27Chip = styled(Chip)`
  border: 1px solid transparent;
  background:
    linear-gradient(var(--c-nd-50-opaque), var(--c-nd-50-opaque)) padding-box,
    var(--chip-border-color) border-box;
  font: var(--t-brand-xxs);
  color: var(--chip-text-color);
  box-sizing: content-box;
  text-transform: uppercase;

  ${({ color = 'transparent' }) => {
    switch (color) {
      case 'red':
        return css`
          --chip-border-color: linear-gradient(
            0deg,
            var(--c-rare-tertiary) 0%,
            var(--c-rare-secondary) 70%,
            #ffb3b4 100%
          );
          --chip-text-color: var(--c-red-400);
          box-shadow: 0 0 12px 0 var(--c-rare) inset;
        `;
      case 'fire':
        return css`
          --chip-border-color: linear-gradient(
            var(--c-modes-pro-tertiary),
            var(--c-modes-pro-tertiary)
          );
          --chip-text-color: var(--c-white);
          --chip-surface-color: color-mix(
            in srgb,
            var(--c-modes-pro-primary) 16%,
            var(--c-dark-primary)
          );
          background:
            linear-gradient(
                var(--chip-surface-color),
                var(--chip-surface-color)
              )
              padding-box,
            var(--chip-border-color) border-box;
          box-shadow: 0 0 9px 0 var(--c-modes-pro-secondary) inset;
        `;
      default:
        return css`
          --chip-border-color: linear-gradient(
            180deg,
            var(--c-common-tertiary) 0%,
            rgba(var(--c-rgb-white), 0.17) 63%,
            var(--c-white) 100%
          );
          --chip-text-color: var(--c-white);
        `;
    }
  }}
`;
